import { cn } from '~/chords/lib/cn';

export const SLIDE_OUT_STATUSES = [
  'isClosed',
  'isClosing',
  'isOpening',
  'isOpen',
] as const;

export const OVERLAY_CLASS = {
  show: cn('animate-dialog-overlay-show'),
  hide: cn('animate-dialog-overlay-hide'),
} as const;

export const CONTENT_CLASS = {
  show: cn('translate-x-0'),
  disable: cn('!pointer-events-none'),
} as const;

export const SIDE_CLASS = {
  right: cn('right-0 border-l border-l-emphasis-subtle'),
  left: cn('left-0 border-r border-r-emphasis-subtle'),
} as const;

export const DEFAULT_CONTENT_WIDTH = '400px';

export const DEFAULT_SIDE = 'right';

export const ANIMATION_DURATION = 300;
